import { createFileRoute, redirect } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { PersonalInformationsForm } from "./-components/forms/PersonalInformationsForm";
import { ChefInformationForm } from "./-components/forms/ChefInformationForm";
import { LocationForm } from "./-components/forms/LocationForm";
import { BannerForm } from "./-components/forms/BannerForm";
import { chefQueries } from "@/domain/chef/chef.query";

export const Route = createFileRoute("/dashboard/chef/profil")({
  component: RouteComponent,
  loader: async ({ context }) =>
    context.queryClient.ensureQueryData(chefQueries.me()).catch(() => {
      throw redirect({
        to: "/connexion",
      });
    }),
});

function RouteComponent() {
  const { data } = useSuspenseQuery(chefQueries.me());

  return (
    <div className="min-h-screen sm:px-6 py-4 px-2 sm:py-6">
      <h1 className="font-h1 ">Votre profil</h1>
      <p className="font-p text-muted-foreground">Gérez votre profil</p>
      <section className="flex flex-col gap-4 mt-8 max-md:mt-4 ">
        <PersonalInformationsForm
          firstName={data.firstName}
          lastName={data.lastName}
          email={data.email}
          phone={data.phone}
          avatar={data.avatar}
        />
        <div className="flex flex-col md:flex-row gap-4 ">
          <ChefInformationForm
            languages={data.languages}
            specialisation={data.specialties}
            description={data.description}
          />
          <LocationForm workingCity={data.workingCity} radius={data.radius} />
        </div>
        <BannerForm banner={data.banner} />
      </section>
    </div>
  );
}
